<script setup>
import { Form } from 'vee-validate'
import {reactive, ref} from 'vue'
import axios from 'axios'
import cookieHelper from '../cookie'
import {useFormSubmit} from '../../composables/useFormSubmit'
const { hideModal } = useFormSubmit()

const confirmation = reactive({show: false, message: '', class: ''})
let isSubmitting = ref(false)
const onSubmit = async () => {
  confirmation.show = true
  confirmation.class = 'message--warning'
  confirmation.message = 'Submitting....'
  isSubmitting.value = true
  const form  = document.getElementById('enquirySuccessForm');
  let formData = new FormData(form);
  window.grecaptcha.execute(document.getElementById('mySiteKeyVariable').value, {
    action: formData.get('captcha_action'),
  }).then((token) => {
    const submitButton = form.querySelector('.submit');
    submitButton.disabled = true;
    formData.set('g-recaptcha-response', token);
    axios.post('/enquiry-success-submitted', formData).then(function (response) {
      confirmation.class = 'message--success'
      confirmation.message = response.data.msg

      const successData = JSON.stringify(
        {
          interested: formData.get('interested'),
          lookingMove: formData.get('looking-move'),
          myAge: formData.get('my-age'),
          myPartnerAge: formData.get('my-partner-age'),
        },
      );
      cookieHelper.setCookie('villageInfoSuccessInfo', successData, 365);
      setTimeout(function () {
        hideModal();
      }, 4000);
    })
  })
}
</script>
<template>
  <Form
    id="enquirySuccessForm"
    @submit="onSubmit"
    class="modal-form modal-form--extra-info-form"
  >
    <p>So we can best respond to your enquiry, please complete the below questions.</p>
    <p class="mb-6">
      <i>Nb: If you are looking on behalf of someone, answer questions as relevant to the potential resident.</i>
    </p>
    <slot name="token"></slot>
    <div class="row">
      <div class="col-md-12 mb-6">
        <label class="d-block mb-5 mb-md-2"><strong>I’m interested in retirement villages:</strong></label>
        <div class="radio-custom radio-custom--inline">
          <input type="radio" id="for-myself" name="interested" value="For myself">
          <label class="form-check-label" for="for-myself">For myself</label>
        </div>
        <div class="radio-custom radio-custom--inline">
          <input type="radio" id="on-behalf" name="interested" value="On behalf of someone else">
          <label class="form-check-label" for="on-behalf">On behalf of someone else</label>
        </div>
      </div>
      <div class="col-md-12 mb-6">
        <label class="d-block mb-5 mb-md-2"><strong>I’m looking to move:</strong></label>
        <div class="radio-custom radio-custom--inline">
          <input type="radio" id="now" name="looking-move" value="Now">
          <label class="form-check-label" for="now">Now</label>
        </div>
        <div class="radio-custom radio-custom--inline">
          <input type="radio" id="next-12-months" name="looking-move" value="Within the next 12 months">
          <label class="form-check-label" for="next-12-months">In the next 12 months</label>
        </div>
        <div class="radio-custom radio-custom--inline">
          <input type="radio" id="option-future" name="looking-move" value="Considering options for the future">
          <label class="form-check-label" for="option-future">Considering options for the future</label>
        </div>
      </div>

      <div class="col-md-12 mb-6">
        <label class="d-block mb-5 mb-md-2"><strong>I am:</strong></label>
        <div class="radio-custom radio-custom--inline">
          <input type="radio" id="over-60" name="my-age" value="Over 60 years">
          <label class="form-check-label" for="over-60">Over 60 years</label>
        </div>
        <div class="radio-custom radio-custom--inline">
          <input type="radio" id="over-65" name="my-age" value="Over 65 years">
          <label class="form-check-label" for="over-65">Over 65 years</label>
        </div>
        <div class="radio-custom radio-custom--inline">
          <input type="radio" id="over-70" name="my-age" value="Over 70 years">
          <label class="form-check-label" for="over-70">Over 70 years</label>
        </div>
        <div class="radio-custom radio-custom--inline">
          <input type="radio" id="over-75" name="my-age" value="Over 75 years">
          <label class="form-check-label" for="over-75">Over 75 years</label>
        </div>
      </div>

      <div class="col-md-12 mb-6">
        <label class="d-block mb-5 mb-md-2"><strong>My partner(if applicable) is:</strong></label>
        <div class="radio-custom radio-custom--inline">
          <input type="radio" id="over-60-partner" name="my-partner-age" value="Over 60 years">
          <label class="form-check-label" for="over-60-partner">Over 60 years</label>
        </div>
        <div class="radio-custom radio-custom--inline">
          <input type="radio" id="over-65-partner" name="my-partner-age" value="Over 65 years">
          <label class="form-check-label" for="over-65-partner">Over 65 years</label>
        </div>
        <div class="radio-custom radio-custom--inline">
          <input type="radio" id="over-70-partner" name="my-partner-age" value="Over 70 years">
          <label class="form-check-label" for="over-70-partner">Over 70 years</label>
        </div>
        <div class="radio-custom radio-custom--inline">
          <input type="radio" id="over-75-partner" name="my-partner-age" value="Over 75 years">
          <label class="form-check-label" for="over-75-partner">Over 75 years</label>
        </div>
      </div>

      <div class="col-md-12">
        <div :class="confirmation.class" class="message" v-if="confirmation.show">{{ confirmation.message }}</div>
        <div class="form-group mt-5">
          <button type="submit" class="btn btn--green btn--send btn--info-pack submit">
            Send
          </button>
        </div>
      </div>
    </div>
  </Form>

</template>
